<template>
  <nav>
    <div v-if="isAuth || hasCart">
      <v-app-bar flat density="comfortable" order="1"
                 color="background-1"
                 class="elevation-0">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-img class="mr-14"
               max-height="25"
               :src="'/_UPLOAD/logo/img_logo.png'"
               @click="$router.push('/')"></v-img>
      </v-app-bar>
      <v-app-bar v-if="isAuth || hasCart" flat density="compact" color="white" class="elevation-3" order="1">
        <v-spacer></v-spacer>
        <v-chip class="mr-1" color="grey-darken-3" size="small">{{corpName}}</v-chip>
        <span class="mr-2">{{formatPhoneNumber(authInfo.phoneNumber)}}</span>
        <v-btn
            v-if="isAuth || hasCart"
            to="/cart"
            prepend-icon="mdi-cart-variant"
            class="bg-primary ml-0 mr-2"
            size="small"
            variant="flat">
          장바구니
        </v-btn>
      </v-app-bar>
    </div>
    <div v-else>
      <v-app-bar flat density="comfortable" order="1"
                 color="background-1"
                 class="elevation-0">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-img class="mr-14" max-height="25" :src="'/_UPLOAD/logo/img_logo.png'"></v-img>
      </v-app-bar>
    </div>


    <v-navigation-drawer color="background-1" v-model="drawer" temporary order="0">
      <v-list density="compact" nav>
        <v-btn variant="text" icon="mdi-close" @click.stop="drawer = !drawer"></v-btn>
      </v-list>
      <v-list density="compact" nav>
        <v-list-item>
          <v-btn v-if="!isAuth"  variant="outlined" class="ma-1 ml-6 w-75" value="login" to="/login">간편인증</v-btn>
          <v-btn v-else variant="outlined" class="ma-1 ml-6 w-75" value="logout" @click="onLogout">로그아웃</v-btn>
        </v-list-item>
        <v-list-item>
          <v-btn variant="outlined" class="ma-1 ml-6 w-75" value="mobileMembership" to="/membership">모바일회원권</v-btn>
        </v-list-item>
      </v-list>
      <v-list density="compact" nav>
        <v-divider></v-divider>
        <v-list-item prepend-icon="mdi-home" title="홈" value="home" to="/"></v-list-item>
        <v-divider></v-divider>
        <v-list-item prepend-icon="mdi-bed-outline" title="객실" @click="goToRoomPage" value="reservation"></v-list-item>
        <v-divider></v-divider>
        <v-list-item prepend-icon="mdi-cart-variant" title="주문/구매" value="order" to="/upjang"></v-list-item>
        <v-divider></v-divider>
        <v-list-item prepend-icon="mdi-ticket-percent-outline" title="티켓" value="ticket" to="/ticket"></v-list-item>
        <v-divider></v-divider>
        <v-list-item prepend-icon="mdi-receipt-text" title="구매 내역" value="history" to="/order/history"></v-list-item>
        <v-divider></v-divider>
        <v-list-item prepend-icon="mdi-web" title="홈페이지" @click="goToMobileHomePage" value="homePage"></v-list-item>
        <v-divider></v-divider>
      </v-list>
      <template v-slot:append>
        <div class="pb-4">
          <v-divider></v-divider>
          <div class="mx-auto ma-4 w-75">
            <v-select
                :items="corps"
                item-title="detail_name"
                item-value="detail"
                v-model="corp"
                density="compact"
                variant="outlined"
                location="bottom"
                @update:modelValue="changeRoute"
                hide-details></v-select>
          </div>
          <v-img class="mx-auto pa-0" justify="center" max-height="20" :src="'/_UPLOAD/logo/img_logo.png'"></v-img>
        </div>
      </template>
    </v-navigation-drawer>
  </nav>

  <form ref="sitePassForm" action="" method="POST">
    <input type="hidden" name="corp" :value="corpCode">
    <input type="hidden" name="passHpNo" :value="phoneNumber">
  </form>
</template>

<script>
import authStore from '@/store/auth'
import commonStore from '@/store/common'
import cartStore from '@/store/cart'
import {common} from "@/api";

export default {
  name: "MobileNavbar",
  props: {
    forceRerender: Function
  },
  data () {
    return {
      isAuth: false,
      hasCart: false,
      drawer: false,
      authInfo: {},
      corps: [],
      corp: {},
      corpCode: '',
      corpName: '',
      phoneNumber : '',
    }
  },
  created() {
    this.isAuth = authStore.state.authInfo.token !== null
    this.hasCart = cartStore.state.cart.cartKey !== null
    this.authInfo = authStore.state.authInfo
    this.corpCode = commonStore.state.common.corpCode
    this.corpName = commonStore.state.common.corpName
    this.phoneNumber = authStore.state.authInfo.phoneNumber
    this.getCorpsCodes()
  },
  computed: {
    isAuth() {
      return authStore.state.authInfo.token !== null
    },
    authInfo() {
      return authStore.state.authInfo
    },
    corpCode() {
      return commonStore.state.common.corpCode
    },
    corpName() {
      return commonStore.state.common.corpName
    },
    hasCart() {
      return cartStore.state.cart.cartKey !== null
    }
  },
  watch: {
    corp() {
      if ((typeof this.corp) === "string") {
        commonStore.dispatch('setCorpCode', this.corps.find(v => v.detail === this.corp))
      } else if ((typeof this.corp) === "object") {
        commonStore.dispatch('setCorpCode', this.corp)
      }
      this.corpName = commonStore.state.common.corpName
    }
  },
  methods: {
    getCorpsCodes() {
      common.getCommonCode(commonStore.state.common.corpCode, ['CI001'])
          .then(data => {
            console.log(data)
            if (data.data.codes) {
              this.corps = data.data.codes
              this.corp = this.corps.find(v => v.detail === this.corpCode)
            }
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
    onLogout() {
      authStore.dispatch('logout')
          .then(() => {
            cartStore.dispatch('removeCartInfo').then(r => r)
            this.drawer = false
            this.$router.push('/')
          })
    },
    changeRoute() {
      if (this.$route.fullPath === '/') {
        this.$router.go(0)
      }
      this.$router.push('/')
    },
    goToMobileHomePage() {
      window.location.href = "https://www.yongpyong.co.kr/mobile/kor/index.do"
    },
    goToRoomPage() {
      const myForm = this.$refs.sitePassForm;
      myForm.action = process.env.VUE_APP_ROOM_SERVER_URL;
      myForm.submit();
      //window.location.href = process.env.VUE_APP_ROOM_SERVER_URL + "?corp=" + commonStore.state.common.corpCode + "&passHpNo=" + authStore.state.authInfo.phoneNumber
    }
  }
}
</script>

<style scoped>

</style>